import { render, staticRenderFns } from "./ManualProcessingView.vue?vue&type=template&id=0b1cc0b3&scoped=true&"
import script from "./ManualProcessingView.vue?vue&type=script&lang=js&"
export * from "./ManualProcessingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1cc0b3",
  null
  
)

export default component.exports